module.exports = __webpack_public_path__ + "static/media/india_flag.7038cadf.svg";